export default {
      id: "icon-info-light-black-usage",
      viewBox: "0 0 16 16",
      url: "/" + "images/icons.3.109.2.svg#icon-info-light-black-usage",
      toString: function () {
        return this.url;
      }
    }